<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'AboutCommitteesHeader',
  inject: ['wp']
}
</script>
